import { IPendingConfigStorage } from "@/services/storage/base/storage-abstractions";
import { VocalRemoverConfig } from "@/components/pages/vocal-remover/hooks/use-start-vocal-remove";
import { PendingConfigStorageMixin } from "@/services/storage/storage-mixins/pending-config-storage-mixin";
import { MediaInputStorage } from "@/services/storage/base/media-input-storage";

class VocalRemoverSessionStorage
  extends MediaInputStorage
  implements IPendingConfigStorage<VocalRemoverConfig>
{
  constructor() {
    super("vocalRemoverCache", "VocalRemoverDB");
  }

  pendingConfigStorage = new PendingConfigStorageMixin<VocalRemoverConfig>(
    this.storeName,
    this.databaseName,
  );
}

const vocalRemoverSessionStorage = new VocalRemoverSessionStorage();
export { vocalRemoverSessionStorage };
